
<template>
    <el-cascader class="x-cascader" :model-value="modelValue" :options="options(mergeFilter(config.localFilter, config.pathFilter), data)" :props="getProps(config.props)" :disabled="readonly"
        collapse-tags collapse-tags-tooltip clearable 
        @update:modelValue="(value, oldvalue)=>$emit('update:modelValue', value, oldvalue)"
    ></el-cascader>
</template>
<script setup>
import SelectType from "../data/SelectType";
import { getOptions, mergeFilter } from '../utils.js';

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null },
});

defineEmits({
    "update:modelValue": null,
});

const DEFAULT_PROPS = {emitPath: false, checkStrictly:true};

const options = (filter, data)=> {
    return getOptions(props.config?.dataOptions, filter,  data);
}
const getProps = (config)=> {
    return Object.assign({multiple: props.config?.selectType == SelectType.MULTIPLE_SELECT, checkStrictly:props.config?.selectType != SelectType.MULTIPLE_SELECT}, DEFAULT_PROPS, config);
}
</script>
<style>
.x-cascader {
    width: 100% !important;
}
.x-cascader input {
    height: 30px !important;
}
</style>